/**
 * Carrossel de vídeo: referência customer-reviews.
 * Sem loop: no último card impede prosseguir; no primeiro impede voltar.
 * Setas desabilitadas nos limites.
 */
(function () {
  const BREAKPOINT_DESKTOP = 1400;
  const BREAKPOINT_MOBILE = 750;
  const DESKTOP_SLIDES_5 = 5;
  const DESKTOP_SLIDES_3 = 3;
  const MOBILE_PEEK_PERCENT = 0.25; // 25% do próximo/anterior visível

  function getSlideWidth(slidesCount, isMobile) {
    if (isMobile) {
      const visible = 1 + 2 * MOBILE_PEEK_PERCENT;
      return (100 / visible).toFixed(2) + '%';
    }
    const n = slidesCount >= BREAKPOINT_DESKTOP ? DESKTOP_SLIDES_5 : DESKTOP_SLIDES_3;
    return (100 / n).toFixed(2) + '%';
  }

  function initSection(section) {
    const viewport = section.querySelector('.jv-video-carousel__viewport');
    const track = section.querySelector('.jv-video-carousel__track');
    if (!viewport || !track) return;

    const cards = Array.from(track.querySelectorAll('.jv-video-carousel-card'));
    const count = cards.length;
    if (count === 0) return;

    const autoplay = section.dataset.autoplay === 'true';
    const autoplaySpeed = (parseInt(section.dataset.autoplaySpeed, 10) || 5) * 1000;
    let autoplayTimer = null;
    let currentIndex = 0;
    let isMobile = false;
    let visibleCount = DESKTOP_SLIDES_5;

    function getMaxIndex() {
      if (isMobile) return Math.max(0, count - 1);
      return Math.max(0, count - visibleCount);
    }

    function parseGap() {
      var gapVal = getComputedStyle(track).gap;
      if (!gapVal || gapVal === 'normal') return 0;
      var px = parseFloat(gapVal);
      return Number.isFinite(px) ? px : 0;
    }

    function setSlidesVariables() {
      const w = window.innerWidth;
      isMobile = w < BREAKPOINT_MOBILE;
      visibleCount = w >= BREAKPOINT_DESKTOP ? DESKTOP_SLIDES_5 : DESKTOP_SLIDES_3;
      const desktopPct = 100 / (w >= BREAKPOINT_DESKTOP ? DESKTOP_SLIDES_5 : DESKTOP_SLIDES_3);
      section.style.setProperty('--slide-width', desktopPct.toFixed(2) + '%');
      section.style.setProperty('--slide-width-mobile', getSlideWidth(count, true));

      var viewportWidth = viewport.offsetWidth || w;
      if (viewportWidth <= 0) return;
      var gap = parseGap();
      var slotWidthPx;
      if (isMobile) {
        var visible = 1 + 2 * MOBILE_PEEK_PERCENT;
        slotWidthPx = viewportWidth / visible;
      } else {
        slotWidthPx = viewportWidth / visibleCount;
      }
      var cardWidthPx = Math.max(0, slotWidthPx - gap);
      section.style.setProperty('--slide-width-px', cardWidthPx + 'px');
      var trackWidthPx = count * cardWidthPx + (count - 1) * gap;
      section.style.setProperty('--track-width', trackWidthPx + 'px');
    }

    function getCardWidth() {
      var gap = parseGap();
      var viewportWidth = viewport.offsetWidth;
      var slotWidthPx;
      if (isMobile) {
        var visible = 1 + 2 * MOBILE_PEEK_PERCENT;
        slotWidthPx = viewportWidth / visible;
      } else {
        slotWidthPx = viewportWidth / visibleCount;
      }
      return Math.max(0, slotWidthPx - gap);
    }

    function goToIndex(index) {
      var maxIndex = getMaxIndex();
      currentIndex = Math.max(0, Math.min(index, maxIndex));

      var cardWidth = getCardWidth();
      var gap = parseGap();
      var offset = currentIndex * (cardWidth + gap);

      if (isMobile) {
        var totalContent = count * cardWidth + (count - 1) * gap;
        var cs = getComputedStyle(viewport);
        var pl = parseFloat(cs.paddingLeft) || 0;
        var pr = parseFloat(cs.paddingRight) || 0;
        var maxOffset = totalContent + pl + pr - viewport.offsetWidth;
        if (maxOffset > 0 && offset > maxOffset) offset = maxOffset;
      }

      track.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';

      var uniformHeight = section.dataset.uniformVideoHeight === 'true';
      cards.forEach(function (c) { c.classList.remove('is-center'); });
      if (!uniformHeight) {
        var centerTrackIndex = currentIndex + Math.floor(visibleCount / 2);
        var realCenter = centerTrackIndex < count ? centerTrackIndex : count - 1;
        if (cards[realCenter]) cards[realCenter].classList.add('is-center');
      }

      updateButtons();
    }

    function updateButtons() {
      var prevBtn = section.querySelector('[data-jv-carousel-prev]');
      var nextBtn = section.querySelector('[data-jv-carousel-next]');
      var maxIndex = getMaxIndex();
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }

    function next() {
      var maxIndex = getMaxIndex();
      if (currentIndex >= maxIndex) {
        stopAutoplay();
        return;
      }
      goToIndex(currentIndex + 1);
      if (autoplay) resetAutoplay();
    }

    function prev() {
      if (currentIndex <= 0) return;
      goToIndex(currentIndex - 1);
      if (autoplay) resetAutoplay();
    }

    function startAutoplay() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || count <= 1) return;
      stopAutoplay();
      autoplayTimer = setTimeout(function () {
        next();
        startAutoplay();
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function resetAutoplay() {
      stopAutoplay();
      if (autoplay) startAutoplay();
    }

    function applyLayout() {
      setSlidesVariables();
      goToIndex(currentIndex);
    }
    applyLayout();
    updateButtons();
    if (autoplay) startAutoplay();

    function kickVideoInMedia(media) {
      var dm = media.querySelector('deferred-media');
      if (dm && typeof dm.loadContent === 'function' && !dm.getAttribute('data-media-loaded')) {
        try {
          dm.loadContent(false);
        } catch (e) {}
      }
      var v = media.querySelector('video');
      if (v) {
        try {
          v.playsInline = true;
          v.setAttribute('playsinline', '');
          v.setAttribute('webkit-playsinline', '');
        } catch (e) {}
        try {
          if (v.readyState < 2) v.load();
        } catch (e) {}
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      }
    }

    function setupCarouselVideoAutoplaySafari() {
      // threshold 0 + isIntersecting: exigir ratio ≥ 0.2 pausava o vídeo no mobile (Safari) quando o slide estava visível mas com ratio baixo.
      var opts = { root: viewport, rootMargin: '0px', threshold: 0 };
      section.querySelectorAll('.jv-video-carousel-card[data-video-autoplay="true"]').forEach(function (card) {
        var media = card.querySelector('.jv-video-carousel-card__media');
        if (!media) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = media.querySelector('video');
            if (entry.isIntersecting) {
              kickVideoInMedia(media);
            } else if (v) {
              v.pause();
            }
          });
        }, opts);
        io.observe(media);
      });
    }
    setupCarouselVideoAutoplaySafari();

    var resizeObserver = new ResizeObserver(function () {
      setSlidesVariables();
      goToIndex(currentIndex);
    });
    resizeObserver.observe(viewport);

    var prevBtn = section.querySelector('[data-jv-carousel-prev]');
    var nextBtn = section.querySelector('[data-jv-carousel-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', function () {
      if (autoplay) startAutoplay();
    });

    let startX = 0;
    let currentX = 0;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      currentX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function () {
      const diff = startX - currentX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) next();
        else prev();
      }
    });

    window.addEventListener('resize', function () {
      setSlidesVariables();
      goToIndex(currentIndex);
    });
    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        setSlidesVariables();
        goToIndex(currentIndex);
      }, 100);
    });

    function updateMuteButtonState(btn, muted) {
      btn.setAttribute('aria-pressed', muted ? 'true' : 'false');
      btn.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
    }

    function handleMuteClick(e) {
      var btn = e.target.closest('[data-video-mute-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var card = btn.closest('.jv-video-carousel-card');
      if (!card) return;
      var media = card.querySelector('.jv-video-carousel-card__media');
      if (!media) return;
      var video = media.querySelector('video');
      var iframe = media.querySelector('iframe');
      if (video) {
        video.muted = !video.muted;
        updateMuteButtonState(btn, video.muted);
      } else if (iframe && iframe.src && (iframe.src.indexOf('youtube') !== -1 || iframe.src.indexOf('vimeo') !== -1)) {
        var muted = btn.getAttribute('aria-pressed') === 'true';
        if (iframe.src.indexOf('youtube') !== -1) {
          try {
            iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: muted ? 'unMute' : 'mute', args: '' }), '*');
          } catch (err) {}
        }
        updateMuteButtonState(btn, !muted);
      }
    }

    section.addEventListener('click', handleMuteClick);

    function syncMuteButtonStates() {
      section.querySelectorAll('[data-video-mute-toggle]').forEach(function (btn) {
        var card = btn.closest('.jv-video-carousel-card');
        if (!card) return;
        var media = card.querySelector('.jv-video-carousel-card__media');
        if (!media) return;
        var video = media.querySelector('video');
        if (video) updateMuteButtonState(btn, video.muted);
      });
    }
    setTimeout(syncMuteButtonStates, 100);
    section.addEventListener('shopify:block:select', syncMuteButtonStates);
  }

  function init() {
    document.querySelectorAll('.jv-video-carousel').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector('.jv-video-carousel');
    if (section) initSection(section);
  });
})();
